import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, CheckCircle2, ArrowLeft } from "lucide-react";
import { api } from "../lib/api";

export default function Success() {
  const [params] = useSearchParams();
  const donationId = params.get("d");
  const [donation, setDonation] = useState(null);

  useEffect(() => {
    if (!donationId) return;
    api.get(`/donations/status/${donationId}`).then(r => setDonation(r.data)).catch(() => {});
  }, [donationId]);

  return (
    <div className="min-h-screen bg-alabaster flex items-center justify-center p-6" data-testid="success-page">
      <motion.div
        initial={{ opacity: 0, y: 20, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="max-w-xl w-full bg-white rounded-3xl p-10 md:p-14 border border-stone-border/60 shadow-medium text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-olive-light mb-6"
        >
          <Heart className="w-10 h-10 text-terracotta fill-terracotta" />
        </motion.div>

        <h1 className="font-heading text-4xl md:text-5xl font-semibold text-ink mb-3">
          Thank you, <em className="text-terracotta not-italic font-normal italic">from the bottom of our hearts.</em>
        </h1>
        <p className="text-lg text-ink-body leading-relaxed mb-8">
          Your generosity will bring warmth, meals, and comfort to those who need it most.
        </p>

        {donation && (
          <div className="bg-bone rounded-2xl p-6 text-left space-y-3 mb-8" data-testid="donation-summary">
            <div className="flex justify-between text-sm">
              <span className="text-ink-muted">Donation Amount</span>
              <span className="font-semibold text-ink">${Number(donation.amount).toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-ink-muted">Donor</span>
              <span className="font-medium text-ink">{donation.donor_name || "Anonymous"}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-ink-muted">Status</span>
              <span className="inline-flex items-center gap-1 font-medium text-olive capitalize">
                <CheckCircle2 className="w-4 h-4" />
                {donation.status}
              </span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-ink-muted">Reference</span>
              <span className="font-mono text-xs text-ink">{donation.order_id}</span>
            </div>
          </div>
        )}

        <Link
          to="/"
          data-testid="return-home-btn"
          className="inline-flex items-center gap-2 border border-stone-border hover:border-terracotta text-ink-body hover:text-terracotta rounded-full px-8 py-3.5 font-medium transition-all duration-300"
        >
          <ArrowLeft className="w-4 h-4" /> Return home
        </Link>
      </motion.div>
    </div>
  );
}
